import React, { useState, useEffect, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "../../actions"
import Modal from "react-responsive-modal"
import submitData from "helpers/submitData"
import _ from "lodash"
import moment from "moment"
import settings from "settings"
import { toast } from "react-toastify"
import superagent from "superagent"
import * as mapboxgl from "mapbox-gl"
import ArcRepetitionMap from "containers/mapping/arcRepetitionMap"
import currentUser from "helpers/currentUser"
import ARCLotHistory from "containers/modals/arcLotHistory"
import ArcSubmitLot from "containers/entry/modals/arcSubmitLot"
import submitDataAsync from "helpers/asyncSubmitData"
import helpers from "helpers/helpers"
import classNames from "classnames"
mapboxgl.accessToken = settings.mapboxKey

function ArcReviewLot(props) {
	const [data, setData] = useState(false)
	const [permDeleteModal, setPermDeleteModal] = useState(false)
	const [approvalComments, setApprovalComments] = useState("")
	const [conditionalComments, setConditionalComments] = useState("")
	const [approval_file, setApproval_file] = useState({})
	const [conditional_file, setConditional_file] = useState({})
	const [rejection_file, setRejection_file] = useState(null)
	const [rejectionReason, setRejectionReason] = useState("")
	const [lot, setLot] = useState(null)
	const [section, setSection] = useState("")
	const loggedInUser = currentUser()
	const [showHistory, setShowHistory] = useState(false)
	const [showEditSubmission, setShowEditSubmission] = useState(false)

	useEffect(() => {
		if (props.open) {
			build()
		}
	}, [props.open])

	useEffect(() => {
		build()
	}, [props.payload])

	const build = async () => {
		let lot = _.find(props.payload.exec.lots, { id: props.id })
		if (lot) {
			lot = _.cloneDeep(lot)
			setData(lot)
			setApprovalComments(_.get(lot, `arc_data.approval_comments`) || "")
			setConditionalComments(_.get(lot, `arc_data.conditional_comments`) || "")
			setRejectionReason(_.get(lot, `arc_data.reason`) || "")
			let secLook = _.find(props.payload.public.sections, { id: lot.section_id })
			if (secLook) {
				setSection(secLook.name)
			}
		} else {
			setData(false)
		}
	}

	const answerLotReview = (status) => {
		props.loadingStatus(true)
		let d = {
			id: data.id,
			status,
		}
		let file
		if (status == "conditional") {
			// conditionally approved
			d.conditional_comments = conditionalComments
			file = conditional_file
		} else if (status) {
			// approved
			d.approval_comments = approvalComments
			file = approval_file
			d.approved_by = loggedInUser.id
		} else if (!status) {
			// rejected
			d.reason = rejectionReason
			file = rejection_file
		}
		var user = localStorage.getItem("user")
		let req = superagent.post(settings.ep + "/arcAnswerLotReview")
		if (file && file.size) {
			req.attach("file", file)
		}
		req.field("data", JSON.stringify(d))
		req.set("Authorization", user)
		req.end((e, resp) => {
			if (e) {
				console.log(e)
				toast.error(`Error encountered when updating lot.`)
				return
			}
			toast.success(resp.body.message)
			props.alert("modal")
			props.loadingStatus(false)
		})
	}

	const customLotFields = () => {
		if (settings?.arcCustomLotFields) {
			let ret = []
			_.forEach(settings.arcCustomLotFields, (field) => {
				if (field.properties.includes("*") || field.properties.includes(data.property_id)) {
					// If this is a date field, format the date using moment js
					let val = arcData ? arcData[field.dbName] : ""
					if (field.type === "date") {
						val = val ? moment.unix(val).format("MM/DD/YYYY") : ""
					}
					ret.push(
						<div key={field.dbName}>
							<div className="arcModal__lineTitle">{field.name}</div>
							<div className="arcModal__data">{val}</div>
						</div>
					)
				}
			})
			return ret
		}
		return null
	}

	const saveComments = () => {
		let f = {
			approval_comments: approvalComments,
			conditional_comments: conditionalComments,
			reason: rejectionReason,
			lot_id: data.id,
		}
		submitData("arcLotUpdateNotes", f)
			.then((data) => {
				toast.success(data.message)
				props.getPayload()
			})
			.catch((e) => {
				toast.error(e.message)
			})
	}

	const currentFile = (type) => {
		try {
			let arcData = data.arc_data
			if (!arcData) return ""
			if (arcData[type + "_file"]) {
				return (
					<a
						className="ml-2 text-xs font-bold"
						href={`${settings.s3}${arcData[type + "_file"]}`}
						target="_blank">
						[ Current File ]
					</a>
				)
			}
		} catch (e) {
			console.log(e)
		}
	}

	if (!data) {
		return ""
	}
	const { open } = props
	let arcData = data.arc_data
	if (!arcData) return ""
	let builder = _.find(props.payload.public.builders, { id: data.builder })
	let builderName = builder ? ` | ${builder.name}` : ""
	let sp = _.find(props.payload.public.salespeople, { id: arcData.user })
	let fp = _.find(props.payload.public.floorplans, { id: arcData.floorplan })
	let salesperson = sp ? ` | ${sp.first} ${sp.last}` : ""
	//? This logic will attempt to convert materials that are just numbers into their names from materials
	try {
		let fields = helpers.arcFields()
		_.forEach(arcData, (v, k) => {
			if (!fields.includes(k)) return
			arcData[k] = helpers.outputMaterial(k, v, props.payload.public)
		})
	} catch (e) {
		console.log(e)
	}
	// for the future
	/* let elevation = arcData.elevation
	if(typeof elevation === 'number') {
		let look = _.find(props.payload.public.elevations, { id: elevation, builder: data?.builder })
		if(look) {
			elevation = look.name
		}
	} */
	let feeStatus = null
	try {
		if (settings.arcFeeStatus && data?.addl?.feesTable) {
			let status = true
			_.forEach(data.addl.feesTable, (fee) => {
				if (!fee.status) status = false
			})
			feeStatus = (
				<div
					className={classNames("text-white px-2 py-1 text-xs cursor-pointer rounded-lg ml-2", {
						"bg-red-500": !status,
						"bg-green-700": status,
					})}>
					{status ? "All Fees Paid" : "Fees Outstanding"}
				</div>
			)
		}
	} catch (e) {
		console.log(e)
	}
	let rawLot = _.find(props.payload.exec.lots, { id: data.id })

	return (
		<div>
			<Modal
				open={open}
				onClose={() => {
					props.onClose()
				}}
				center
				classNames={{ modal: "arcModal" }}>
				<div className="flex">
					<h3 className="mr-10">
						Plan Submission: {data.address}
						{builderName}
						{salesperson}
					</h3>
					<div
						className="flex items-center"
						onClick={() => {
							setShowHistory(true)
						}}>
						<a className="bg-blue px-2 py-1 rounded-lg text-xs text-white cursor-pointer mr-2">
							View History
						</a>
					</div>
					<div
						className="flex items-center"
						onClick={() => {
							setShowEditSubmission(true)
						}}>
						<a className="bg-green-600 px-2 py-1 rounded-lg text-xs text-white cursor-pointer mr-2">
							Edit Submission
						</a>
					</div>
					<div
						className="bg-red-500 text-white px-2 py-1 text-xs cursor-pointer rounded-lg"
						onClick={() => {
							setPermDeleteModal(true)
						}}>
						Permanently Delete Lot Submission
					</div>
					{data?.arc_data?.current_status === "conditional" ||
					data?.arc_data?.current_status === "approved" ? (
						<div
							className="btn text-xs ml-2"
							onClick={async () => {
								props.loadingStatus(true)
								let resp = await submitDataAsync("mainIngest", {
									lot_id: data.id,
									action: "buildLotResponseFile",
								})
								let url = settings.s3 + "/" + resp.message
								if (resp.status == 200) {
									toast.success("Response file generated")
									window.open(url, "_blank")
								} else {
									toast.error("Error generating response file")
								}
								props.loadingStatus(false)
							}}>
							Generate Response File
						</div>
					) : null}
					{feeStatus}
				</div>
				<div className="documentModal__info">
					<p>
						LBS: {data.lot}/{data.block}/{section}
					</p>
				</div>
				<div className="arcModal__dataLine">
					<div>
						<div className="arcModal__lineTitle">Floorplan</div>
						<div className="arcModal__data">{fp ? fp.name : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Elevation</div>
						<div className="arcModal__data">{arcData?.elevation || ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Sqft</div>
						<div className="arcModal__data">{arcData ? arcData.sqft : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Brick</div>
						<div className="arcModal__data">{arcData ? arcData.brick : ""}</div>
					</div>
					{settings?.arcLotFieldHides?.[data?.property]?.includes("brick_material") ? null : (
						<div>
							<div className="arcModal__lineTitle">Brick Material</div>
							<div className="arcModal__data">{arcData ? arcData.brick_material : ""}</div>
						</div>
					)}
					<div>
						<div className="arcModal__lineTitle">Stucco</div>
						<div className="arcModal__data">{arcData ? arcData.stucco : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Stone</div>
						<div className="arcModal__data">{arcData ? arcData.stone : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">{settings?.renames?.accent_color || "Accent Color"}</div>
						<div className="arcModal__data">{arcData ? arcData.accent_color : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Garage Color</div>
						<div className="arcModal__data">{arcData ? arcData.garage_color : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Roof Color</div>
						<div className="arcModal__data">{arcData ? arcData.roof_color : ""}</div>
					</div>
					{settings?.arcLotFieldHides?.[data?.property]?.includes("door_color") ? null : (
						<div>
							<div className="arcModal__lineTitle">Door Color</div>
							<div className="arcModal__data">{arcData ? arcData.door_color : ""}</div>
						</div>
					)}
					<div>
						<div className="arcModal__lineTitle">Trim</div>
						<div className="arcModal__data">{arcData ? arcData.trim : ""}</div>
					</div>
					<div>
						<div className="arcModal__lineTitle">Siding</div>
						<div className="arcModal__data">{arcData ? arcData.siding : ""}</div>
					</div>
					{settings?.arcLotFieldHides?.[data?.property]?.includes("siding_type") ? null : (
						<div>
							<div className="arcModal__lineTitle">Siding Type</div>
							<div className="arcModal__data">{arcData ? arcData.siding_type : ""}</div>
						</div>
					)}
					<div>
						<div className="arcModal__lineTitle">Masonry %</div>
						<div className="arcModal__data">{arcData ? arcData.masonry_percent : ""}</div>
					</div>
					{settings?.arcLotFieldHides?.[data?.property]?.includes("roof_pitch") ? null : (
						<div>
							<div className="arcModal__lineTitle">Roof Pitch</div>
							<div className="arcModal__data">{arcData ? arcData.roof_pitch : ""}</div>
						</div>
					)}

					{settings?.arcLotFieldHides?.[data?.property]?.includes("total_height") ? null : (
						<div>
							<div className="arcModal__lineTitle">Total Height</div>
							<div className="arcModal__data">{arcData ? arcData.total_height : ""}</div>
						</div>
					)}

					{arcData?.driveway_position ? (
						<div>
							<div className="arcModal__lineTitle">Drive Pos</div>
							<div className="arcModal__data">{arcData ? arcData.driveway_position : ""}</div>
						</div>
					) : null}
					{customLotFields()}
					<div>
						<div className="arcModal__lineTitle">Plan Package</div>
						<div className="arcModal__data">
							{arcData && arcData.plan_file && (
								<a href={`${settings.s3}${arcData.plan_file}`} target="_blank">
									View Plan
								</a>
							)}
						</div>
					</div>
				</div>
				{arcData && arcData.arc_options && (
					<div className="arcModal__comments">
						<p className="big blue">Options:</p>
						<p>{arcData.arc_options}</p>
					</div>
				)}
				{arcData && arcData.variance && (
					<div className="arcModal__comments">
						<p className="big text-red-600">Requested Variance:</p>
						<p>{arcData.variance}</p>
					</div>
				)}
				{arcData && arcData.comments && (
					<div className="arcModal__comments">
						<p className="big blue">Comments:</p>
						<p>{arcData.comments}</p>
					</div>
				)}
				{/* This system was for provident so they can notify jerry to review his side. */}
				{settings?.enabled?.conditionalNotification && (
					<div className="mt-2">
						<p
							className="btn text-xs"
							onClick={() => {
								props.loadingStatus(true)
								submitData("mainIngest", { id: data.id, action: "arcNotifyAdmin" })
									.then((data) => {
										toast.success(data.message)
										props.loadingStatus(false)
									})
									.catch((e) => {
										toast.error(e.message)
									})
							}}>
							Notify Admin
						</p>
						{arcData?.conditionalNotificationSent ? (
							<span className="pl-2 text-xs">
								Notification Sent:{" "}
								{moment.unix(arcData.conditionalNotificationSent).format("MMMM Do YYYY, h:mm a")}
							</span>
						) : null}
					</div>
				)}
				<h2>Plan Map</h2>
				<div className="lotStatus__mapCont lotStatus__mapCont--arc">
					<div className="lotStatus__map pt-4">
						<ArcRepetitionMap id={props.id} lot={lot} interface={"admin"} />
					</div>
				</div>
				<h2>
					Approval{" "}
					<span onClick={() => saveComments()} style={{ marginLeft: 10, fontSize: 12, cursor: "pointer" }}>
						<i className="fas fa-cloud-download" style={{ marginRight: 4 }} />
						Save Comments
					</span>
				</h2>
				<div className="arcModal__approvalBox">
					<div style={{ marginRight: 25 }}>
						<p>Attach Approval File {currentFile("approval")}</p>
						<input
							name="approval_file"
							type="file"
							id="approval_file"
							className="noBorder"
							onChange={(event) => {
								setApproval_file(event.currentTarget.files[0])
							}}
						/>
						<p>Approval Comments</p>
						<textarea
							onChange={(v) => {
								setApprovalComments(v.target.value)
							}}
							value={approvalComments}></textarea>
						<div className="arcModal__approve" onClick={() => answerLotReview(true)}>
							Approve
						</div>
					</div>
					<div style={{ marginRight: 25 }}>
						<p>
							{settings.renameConditional
								? `Attach ${settings.renameConditional} File`
								: "Attach Conditional Approval File"}{" "}
							{currentFile("conditional")}
						</p>
						<input
							name="conditional_file"
							type="file"
							id="conditional_file"
							className="noBorder"
							onChange={(event) => {
								setConditional_file(event.currentTarget.files[0])
							}}
						/>
						<p>
							{settings.renameConditional ? settings.renameConditional : "Conditional Approval"} Comments
						</p>
						<textarea
							onChange={(v) => {
								setConditionalComments(v.target.value)
							}}
							value={conditionalComments}></textarea>
						<div className="arcModal__conditional" onClick={() => answerLotReview("conditional")}>
							{settings.renameConditional ? settings.renameConditional : "Conditionally Approve"}
						</div>
					</div>
					<div className="arcModal__rejectionBox">
						<p>Attach Rejection File {currentFile("rejection")}</p>
						<input
							name="rejection_file"
							type="file"
							id="rejection_file"
							className="noBorder"
							onChange={(event) => {
								setRejection_file(event.currentTarget.files[0])
							}}
						/>
						<p>Rejection Reason:</p>
						<textarea
							onChange={(v) => {
								setRejectionReason(v.target.value)
							}}
							value={rejectionReason}></textarea>
						<div className="arcModal__rejection" onClick={() => answerLotReview(false)}>
							Reject
						</div>
					</div>
				</div>
			</Modal>
			<Modal
				open={permDeleteModal}
				onClose={() => {
					setPermDeleteModal(false)
				}}
				center
				classNames={{
					modal: "modalReset",
				}}>
				<div
					className="text-white bg-red-500 px-3 py-1 mx-28 my-8 cursor-pointer"
					onClick={() => {
						props.loadingStatus(true)
						submitData("mainIngest", { id: data.id, action: "arcDeleteLotSubmission" })
							.then((data) => {
								toast.success(data.message)
								props.alert("modal")
								props.loadingStatus(false)
							})
							.catch((e) => {
								toast.error(e.message)
							})
					}}>
					Confirm Deletion?
				</div>
			</Modal>
			<ARCLotHistory
				open={showHistory}
				data={data}
				onClose={() => {
					setShowHistory(false)
				}}
			/>
			{showEditSubmission && (
				<Modal
					open={showEditSubmission}
					onClose={() => {
						setShowEditSubmission(false)
					}}
					center
					classNames={{ modal: "arcModal arcModal--edit" }}>
					<ArcSubmitLot
						data={rawLot}
						payload={props.payload}
						isSuper={true}
						notify={async (resp) => {
							if (resp.status == 200) {
								toast.success(resp.message)
								setShowEditSubmission(false)
								await props.getPayload()
							} else {
								toast.error(resp.message)
							}
						}}
					/>
				</Modal>
			)}
		</div>
	)
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ArcReviewLot)
